import { render, staticRenderFns } from "./IconWifiSolid.vue?vue&type=template&id=47a1154e"
import script from "./IconWifiSolid.vue?vue&type=script&lang=js"
export * from "./IconWifiSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports